// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UpdateUser_container__NwdqX{
   width: 100%;
   display: flex;
   place-content: center;
}

.UpdateUser_container__NwdqX > div{
    width: 60%;
    margin-top: 50px;
}

.UpdateUser_paper__oVY38 {
    text-align: center;
}

.UpdateUser_buttons__x5YZm{
    display: flex;
    margin-left: 60px;
}

/*DESKTOP*/
@media screen and (min-width:1024px) {
    .UpdateUser_paper__oVY38 {
        height: 500px
    }

    .UpdateUser_privs__yBZSp{
        margin-bottom: 20px;
    }
 }

 /*TABLET*/
 @media screen and (min-width:767px) and (max-width:1024px){
   .UpdateUser_paper__oVY38 {
        height: 440px
    }
    
    .UpdateUser_privs__yBZSp{
        margin-bottom: 15px;
    }
}

 /*MOBILE*/
 @media screen and (max-width:767px){
     .UpdateUser_container__NwdqX > div{
         width: 95%;
     }
 
     .UpdateUser_paper__oVY38 {
         height: 420px;
     }
     
     .UpdateUser_privs__yBZSp{
         margin-bottom: 25px;
     }
}`, "",{"version":3,"sources":["webpack://./src/pages/user_update/UpdateUser.module.css"],"names":[],"mappings":"AAAA;GACG,WAAW;GACX,aAAa;GACb,qBAAqB;AACxB;;AAEA;IACI,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,iBAAiB;AACrB;;AAEA,UAAU;AACV;IACI;QACI;IACJ;;IAEA;QACI,mBAAmB;IACvB;CACH;;CAEA,SAAS;CACT;GACE;QACK;IACJ;;IAEA;QACI,mBAAmB;IACvB;AACJ;;CAEC,SAAS;CACT;KACI;SACI,UAAU;KACd;;KAEA;SACI,aAAa;KACjB;;KAEA;SACI,mBAAmB;KACvB;AACL","sourcesContent":[".container{\n   width: 100%;\n   display: flex;\n   place-content: center;\n}\n\n.container > div{\n    width: 60%;\n    margin-top: 50px;\n}\n\n.paper {\n    text-align: center;\n}\n\n.buttons{\n    display: flex;\n    margin-left: 60px;\n}\n\n/*DESKTOP*/\n@media screen and (min-width:1024px) {\n    .paper {\n        height: 500px\n    }\n\n    .privs{\n        margin-bottom: 20px;\n    }\n }\n\n /*TABLET*/\n @media screen and (min-width:767px) and (max-width:1024px){\n   .paper {\n        height: 440px\n    }\n    \n    .privs{\n        margin-bottom: 15px;\n    }\n}\n\n /*MOBILE*/\n @media screen and (max-width:767px){\n     .container > div{\n         width: 95%;\n     }\n \n     .paper {\n         height: 420px;\n     }\n     \n     .privs{\n         margin-bottom: 25px;\n     }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `UpdateUser_container__NwdqX`,
	"paper": `UpdateUser_paper__oVY38`,
	"buttons": `UpdateUser_buttons__x5YZm`,
	"privs": `UpdateUser_privs__yBZSp`
};
export default ___CSS_LOADER_EXPORT___;
